import React from 'react'
import FirstPage from '../firstPage/FirstPage'
import { pages } from '../pageNumberForm'
import SecondPage from '../secondPage/SecondPage'


const FormPage = ({page, values, setValues, errors, touched, handleChange}) => {

    return (
        page === pages.firstPage
            ? <FirstPage
                    page={page}
                    values={values}
                    setValues={setValues}
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                />
            : <SecondPage
                    page={page}
                    values={values}
                    setValues={setValues}
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                />
    )
}

export default FormPage